// fbConfig.js
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyDCO8pmAJpIdetaNvZEHwEwzOAEFYgm_-c",
  authDomain: "deroyaleacademy.firebaseapp.com",
  projectId: "deroyaleacademy",
  storageBucket: "deroyaleacademy.firebasestorage.app",
  messagingSenderId: "452110666599",
  appId: "1:452110666599:web:bb76a4f0ee326fa7867dc2"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Get Firestore, Auth, and Storage instances
const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const storage = getStorage(firebaseApp);

auth.settings.appVerificationDisabledForTesting = true;

export { db, auth, storage, firebaseConfig };
